import { all, put, fork, call, takeLatest } from 'redux-saga/effects';
import {
  GET_MARKUP_DEDUCT_PERCENTAGE,
  POST_MARKUP_DEDUCT_PERCENTAGE,
  GET_CURRENT_GOLD_AND_SILVER_LIVE_QUOTES_PRICE,
  GET_GOLD_SILVER_PRICE,
  CHANGE_MARKUP_STATUS,
} from '../constants/MarkupDeductPercentage';
import {
  setMarkupDeductPercentage,
  dataUpdated,
  setCurrentGoldAndSilverLiveQuotesPrice,
  setGoldSilverPrice,
  getCurrentGoldAndSilverLiveQuotesPrice,
  getMarkupDeductPercentage,
} from 'redux/actions/MarkupDeductPercentage';
import {
  fetchRequested,
  fetchCompleted,
  displayMessage,
} from 'redux/actions/Ui';
import { env } from 'configs/EnvironmentConfig';
import fetch from 'auth/FetchInterceptor';

export function* fetchMarkupDeductPercentage() {
  yield takeLatest(GET_MARKUP_DEDUCT_PERCENTAGE, function* () {
    try {
      const response = yield call(() => {
        return fetch({
          method: 'post',
          url: env.API_ENDPOINT_URL + '/price-markups/get-latest',
          withCredentials: true,
        });
      });
      const { data: markupDeductPercentage } = response;
      yield put(setMarkupDeductPercentage(markupDeductPercentage));
    } catch (error) {
      // Get markup percentage error
    }
  });
}

export function* postMarkupDeductPercentage() {
  yield takeLatest(POST_MARKUP_DEDUCT_PERCENTAGE, function* (action) {
    try {
      const access_token = localStorage.getItem('AUTH_TOKEN');
      yield put(fetchRequested());
      yield call(() => {
        return fetch({
          method: 'post',
          url: env.API_ENDPOINT_URL + '/price-markups/create',
          data: action.markupDeductPercentage,
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
          withCredentials: true,
        });
      });
      yield put(dataUpdated());
      yield put(displayMessage({ message: 'Price Updated Successfully' }));
    } catch (error) {
      yield put(
        displayMessage({ message: 'Price Update Failed', isError: true })
      );
    } finally {
      yield put(fetchCompleted());
    }
  });
}

export function* fetchCurrentGoldAndSilverLiveQuotesPrice() {
  yield takeLatest(GET_CURRENT_GOLD_AND_SILVER_LIVE_QUOTES_PRICE, function* () {
    try {
      const response = yield call(() => {
        return fetch({
          method: 'get',
          url: env.API_ENDPOINT_URL + '/price-markups/total',
          withCredentials: true,
        });
      });

      const { data: liveQuotes } = response;
      yield put(setCurrentGoldAndSilverLiveQuotesPrice(liveQuotes));
    } catch (error) {
      // Post markup percentage error
    }
  });
}

export function* getGoldAndSilverPrice() {
  yield takeLatest(GET_GOLD_SILVER_PRICE, function* () {
    try {
      const response = yield call(() => {
        return fetch({
          method: 'get',
          url: env.API_ENDPOINT_URL + '/gold-silver-prices',
          withCredentials: true,
        });
      });
      const { data: commodityPrice } = response;
      const goldSilverPrice = {
        Gold1000: {
          Buy: parseFloat(commodityPrice.GoldBuyPrice),
          Sell: parseFloat(commodityPrice.GoldSellPrice),
        },
        Gold500: {
          Buy: commodityPrice.GoldBuyPrice * 0.5,
          Sell: commodityPrice.GoldSellPrice * 0.5,
        },
        Silver1000: {
          Buy: parseFloat(commodityPrice.SilverBuyPrice),
          Sell: parseFloat(commodityPrice.SilverSellPrice),
        },
      };
      yield put(setGoldSilverPrice(goldSilverPrice));
    } catch (error) {
      // Get gold silver price error
    }
  });
}

export function* changeMarkupStatus() {
  yield takeLatest(CHANGE_MARKUP_STATUS, function* (action) {
    try {
      const access_token = localStorage.getItem('AUTH_TOKEN');
      yield put(fetchRequested());
      yield call(() => {
        return fetch({
          method: 'put',
          url:
            env.API_ENDPOINT_URL +
            '/price-markups/change-status' +
            action.data.MarkupId,
          data: { status: action.data.status },
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        });
      });
      if (action.data.status === 'Published') {
        yield put(getMarkupDeductPercentage());
        yield put(
          displayMessage({ message: 'Markup & Deduct Percentage Published' })
        );
      } else {
        yield put(displayMessage({ message: 'Live Quote Stopped' }));
      }
      yield put(getCurrentGoldAndSilverLiveQuotesPrice());
    } catch (error) {
      yield put(displayMessage({ message: 'Process Failed', isError: true }));
    } finally {
      yield put(fetchCompleted());
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(fetchMarkupDeductPercentage),
    fork(postMarkupDeductPercentage),
    fork(fetchCurrentGoldAndSilverLiveQuotesPrice),
    fork(getGoldAndSilverPrice),
    fork(changeMarkupStatus),
  ]);
}
